import { TrimbleLayerApiModel } from '../../../types/models/trimble-layer.model';
import { CreateTrimbleLayerApiRequest } from '../../../types/requests/trimble-layers/create-trimble-layer.request';
import { DeleteTrimbleLayerApiRequest } from '../../../types/requests/trimble-layers/delete-trimble-layer.request';
import { GetTrimbleLayerApiRequest } from '../../../types/requests/trimble-layers/get-trimble-layer.request';
import { SearchTrimbleLayersApiRequest } from '../../../types/requests/trimble-layers/search-trimble-layers.request';
import { UpdateTrimbleLayerApiRequest } from '../../../types/requests/trimble-layers/update-trimble-layer.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createTrimbleLayer = (params: CreateTrimbleLayerApiRequest) =>
  client.post<TrimbleLayerApiModel>('/trimble-layers', params);

export const updateTrimbleLayer = ({ trimbleLayerId, ...params }: UpdateTrimbleLayerApiRequest) =>
  client.patch<TrimbleLayerApiModel>(`/trimble-layers/${trimbleLayerId}`, params);

export const getTrimbleLayer = <T extends TrimbleLayerApiModel>({
  trimbleLayerId,
  ...params
}: GetTrimbleLayerApiRequest) => client.get<T>(`/trimble-layers/${trimbleLayerId}`, { params });

export const searchTrimbleLayers = <T extends TrimbleLayerApiModel>(params: SearchTrimbleLayersApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/trimble-layers`, { params });

export const deleteTrimbleLayer = ({ trimbleLayerId }: DeleteTrimbleLayerApiRequest) =>
  client.delete<void>(`/trimble-layers/${trimbleLayerId}`);
